import { Navigate, type RouteObject } from 'react-router-dom'
import { DirectoryPage } from './DirectoryPage'
import { PartnerPage } from './PartnerPage'
import { OverviewPage } from './OverviewPage'

// Founder, 2026-11-04: / is the company home (it was /app; the partner directory that sat at / is at /directory).
// /directory is both the public directory and the company's Partners page (it was /app/partners); /directory/<slug or
// id> is one partner.
export const routes: RouteObject[] = [
  { path: '/', element: <OverviewPage /> },
  { path: '/directory', element: <DirectoryPage /> },
  { path: '/directory/:slug', element: <PartnerPage /> },
  // The old /start onboarding is gone (CHANGE-019); old links land on the app.
  { path: '/start', element: <Navigate to="/" replace /> },
  { path: '/start/*', element: <Navigate to="/" replace /> },
]
